<template>
  <div>
    
    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="title is-4">
          タグの使い方
        </p>
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          1. タグを付ける
        </p>
        <p class="subtitle subtitle-detail">
          - ツールバーのタグボタンを押す。<br>
          - Home画面でタブを<span style="font-weight:bold">長押し</span>する。
        </p>
        <img src="../../assets/tutorial3_1.gif" width="350px">
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          2. 絞り込む
        </p>
        <p class="subtitle subtitle-detail">
          見たいものだけ表示できます。
        </p>
        <img src="../../assets/tutorial3_2.gif" width="350px">
      </div>
    </section>

  </div>
</template>

<script>
export default {
    name: 'ios',
    mounted() {
		document.title = "3.タグの使い方"
	},
};
</script>

<style lang="scss" scoped>
.is-white {
    background-color:#fcfcfc !important;
}

.title, .subtitle {
  letter-spacing: 0.1em;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Yu Gothic", YuGothic, Verdana, Meiryo, "M+ 1p", sans-serif;
}

.title {
 opacity: 0.85;
}

.hero-body {
  padding-left:12px;
  padding-right:12px;
}

.subtitle-detail {
    font-size: 0.9rem;
}
</style>

